<template>
<div id="app">

  <div class="margin-center  width">
    <el-carousel height="348px" style="margin-top:21px">
      <el-carousel-item v-for="item in bannerList" :key="item.GotoUrl">
        <div @click="onClickItem(item)" style="width:100%;height:100%;cursor:pointer;">
            <img :src="item.Image" style="width:100%;height:100%;">
        </div>
        <!--     <el-image @click="onClickItem(item)" style="width:100%;height:100%;cursor:pointer;" :src="item.Image" fit="cover"></el-image>-->
      </el-carousel-item>
    </el-carousel>
  </div>

  <div v-if="article!=null" class="width bg-white margin-center    backgroud margin-top-30 flex justify-between">
    <div class="flex flex-direction left" style="width:694px;height:389px">
      <img style="width:100%;height:104px;" src="../assets/img/subtitle.png" fit="cover" />

      <el-carousel :interval="4000" type="card" @change="carouselChange" :autoplay='false' indicator-position='none' style="margin-top:20px" height="213px">

        <item v-for="(item, index) in forumList" :key="index">
          <div @click="clickVideo(item.Id,0)" class="carouseldiv flex flex-direction">
            <el-image style="width:100%;height:160px;" :src="item.Image" fit="cover"></el-image>
            <div style="height:53px;padding:8px 16px;" :style="index==carouseId?'background:#d30000;':'background:#b8b8b8'">
              <div :class="index==carouseId?'carouseltvcheck':'carouseltv'">
                {{item.Title}}
              </div>

            </div>

          </div>

        </item>
      </el-carousel>
      <span style="font-size: 14px;margin-top: 18px;color: #333333;">主办单位 : 中宣部宣教局、光明日报社 承办单位 : 光明网</span>
    </div>
    <div style="width:510px;height:389px;background:#fbfbfb;" class="flex flex-direction right">
      <div class="right flex ">
        <!-- @mouseleave="mouseout()" -->
        <div class="bar" @mouseover="mouseover(index)" v-for="(item, index) in article.ChannelList" :class="{active:index==hoverIndex}" @click="checkIndex(index)" :key="index">
          <p :style="hoverIndex==index?'':'border-right: #999999 solid 1px;'" style="  width: 100%;">
            {{item.ChannelName}}
          </p>
        </div>

        <div class="more" @click="clicktabIndex('information')">
          <span>更多资讯></span>
        </div>

      </div>
      <div style="height: 10px;"></div>
      <div @click="articleIndex(item.Id)" :key="index" class="flex itemIndex align-center" v-for="(item, index) in article.ChannelArticlesList[hoverIndex].Articles">
        <img src="../assets/img/list.png" style="width:8px;height:8px" alt="">
        <p style="flex:1;padding:0 7px" class="text-line1">{{item.Title}}</p>
        <span>{{item.CreateTimeStr}}</span>
      </div>
    </div>
  </div>
  <div v-if="ztList.length>0" class="width bg-white margin-center    backgroud margin-top-30">
    <div class="flex justify-between align-center" style="height: 70px;line-height: 70px; width: 100%;">
      <div style="padding-left: 19px;" class="font-size-24 font-color-black font-weight">
        专题学习
      </div>
      <div style="padding-right: 23px;cursor:pointer" class="font-color-999 font-size-14 " @click="clicktabIndex('special')">
        更多 >>
      </div>
    </div>
    <div class="flex flex-wrap">
      <div @click="clickVideo(item.Id,0)" v-for="(item, index) in ztList" :key="index" style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;">
        <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image" alt="">
        </div>
        <div class="backhover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
        <div class="title">
          <img v-if="item.HasPPT" src="../assets/img/ppt.png" alt="">
          <img v-if="item.HasWord" src="../assets/img/word.png" alt="">
          <p :title="item.Title" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;cursor: pointer;">{{item.Title}}</p>

        </div>

        <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
      </div>
    </div>
  </div>
  <div v-if="adagList.length>0" class="width bg-white margin-center    backgroud margin-top-30">
    <div class="flex justify-between align-center" style="height: 70px;line-height: 70px; width: 100%;">
      <div style="padding-left: 19px;" class="font-size-24 font-color-black font-weight">
        爱党爱国
      </div>
      <div style="padding-right: 23px;cursor:pointer" class="font-color-999 font-size-14 " @click="clicktabIndex('lcountry')">
        更多 >>
      </div>
    </div>
    <div class="flex flex-wrap">
      <div @click="clickVideo(item.Id,0)" v-for="(item, index) in adagList" :key="index" style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;">
       <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image"  alt="">
        </div>
        <div class="backhover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
        <div class="title">
          <img v-if="item.HasPPT" src="../assets/img/ppt.png" alt="">
          <img v-if="item.HasWord" src="../assets/img/word.png" alt="">
          <p :title="item.Title" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;cursor: pointer;">{{item.Title}}</p>

        </div>

        <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
      </div>
    </div>
  </div>
  <div v-if="  ctwhList.length>0" class="width bg-white margin-center   margin-top-30 backgroud ">
    <div class="flex justify-between align-center" style="height: 70px;line-height: 70px; width: 100%;">
      <div style="padding-left: 19px;" class="font-size-24 font-color-black font-weight">
        传统文化
      </div>
      <div style="padding-right: 23px;cursor:pointer" class="font-color-999 font-size-14 " @click="clicktabIndex('culture')">
        更多 >>
      </div>
    </div>
    <div class="flex flex-wrap">
      <div @click="clickVideo(item.Id,0)" v-for="(item, index) in ctwhList" :key="index" style="width: 280px;height: 254px; overflow: hidden;margin-left:20px; position: relative;">
      <div style=" width: 280px;height: 168px;">
          <img style=" width: 280px;height: 168px;" :src="item.Image"  alt="">
        </div>
        <div class="backhover">
          <!-- :style="{backgroundImage:'url('+item.Image+')'}" -->

          <div>
            <i class="subMask"></i>
            <i class="playIcon"></i>
          </div>
        </div>
        <div class="title">
          <img v-if="item.HasPPT" src="../assets/img/ppt.png" alt="">
          <img v-if="item.HasWord" src="../assets/img/word.png" alt="">
          <p :title="item.Title" class="font-color-333-red text-line1  font-size-16" style="text-decoration: none;text-align: left;line-height: 20px;;cursor: pointer;">{{item.Title}}</p>

        </div>
        <p class="text-line1 font-color-999 text-left font-size-12" style="margin-top:3px;">主讲人：{{item.Lecturer}}</p>
      </div>
    </div>
  </div>

  <Bottom></Bottom>
</div>
</template>

<script>
import item from './item.vue'
import common from '@/utils/common.js'
export default {
  components: {
    item
  },
  name: 'app',

  data () {
    return {
      show: true,
      carouseId: 0,
      // sizheng: this.Common.listData,
      bannerList: [],
      items: ['时政', '专题', '理论', '党建', '国际', '科技', '教育'],
      itemData: null,
      currentIndex: 0,
      hoverIndex: 0,

      ztList: [],
      adagList: [],
      ctwhList: [],
      forumList: [],
      xxdjtList: null,
      article: null
      // ChannelLis: [],
      // ChannelArticlesList: [],
    }
  },
  created () {
    this.getHome()
  },
  methods: {
    checkIndex (index) {
      this.currentIndex = index
      this.hoverIndex = index
    },
    articleIndex (Id) {
      this.$router.push({
        path: '/infordes',
        query: {
          'Id': Id
        }
      })
    },
    onClickItem (item) {
      if (item.InsideType === 1) {
        window.open(common.http + item.GotoUrl, '_blank')
      } else if (item.InsideType === 2) {
        window.open('https://promotion.bjadks.com/#/?topicId=' + item.DataId, '_blank')
      } else {
        window.open(item.GotoUrl, '_blank')
      }
      //
    },
    getHome () {
      var that = this
      this.getRequest('api/v1/home').then(data => {
        if (data.IsSuccess) {
          that.ztList = data.Data.ZT
          that.adagList = data.Data.ADAG
          that.ctwhList = data.Data.CTWH
          that.bannerList = data.Data.Banners
          that.article = data.Data.Article
          that.forumList = data.Data.Forum
          // that.xxdjtList = data.Data.XXDJT;
        }
      })
    },
    bannerAction: function (item) {
      if (item.GoType === 1) {
        if (item.InsideType === 1) {
          this.clickVideo(item.DataId, 0)
        }
      }
    },
    clickVideo (courseId, videoId) {
      // this.$router.resolve({
      //     name: 'video',
      //     params: {
      //         courseId: courseId,
      //         videoId: videoId
      //     }
      // })
      let routeData = this.$router.resolve({
        name: 'video',
        params: {
          sizheng: 'n',
          courseId: courseId,
          videoId: videoId
        }
      })
      window.open(routeData.href, '_blank')
    },
    clickSiZheng (index) {
      this.$router.push({
        name: 'make' + index
      })
    },
    clicktabIndex (des) {
      this.$router.push({
        name: des
      })
    },
    carouselChange (now, old) {
      this.carouseId = now
    },
    // mouseout () {
    //   this.hoverIndex = this.currentIndex;
    // },
    mouseover (index) {
      // console.log(index)
      this.hoverIndex = index
    }

  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

body {
  background: #ffffff;
  padding: 0 0;
}

.backgroud {
  width: 1220px;

  background: #ffffff;
  box-shadow: 0px 3px 20px 0px #ececec;
}

.backgroud .left {
  box-shadow: 3px 0px 20px 0px #ececec;
}

.backgroud .right {
  box-shadow: -3px 0px 20px 0px #ececec;
}

.backhover {
  width: 280px;
  height: 168px;
  overflow: hidden;
  margin-top: -168px;
  background-size: cover;
  background-repeat: no-repeat;
}

.backhover div {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.backhover .subMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
  filter: alpha(opacity=30);
  z-index: 0;
}

.backhover .playIcon {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 6;
  opacity: 0;
  margin: -30px 0 0 -30px;
  width: 60px;
  height: 60px;
  background: url(https://h5.cdn.bjadks.com/website/wsbgt-zt/999-linshi_szk/play-icon1.png) no-repeat;
  filter: alpha(opacity=0);
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  -webkit-transform: scale(1.5);
  -moz-transform: scale(1.5);
  -ms-transform: scale(1.5);
  transform: scale(1.5);
}

.backhover div:hover .subMask {
  display: block;
  z-index: 5;
}

.backhover div:hover .playIcon {
  z-index: 6;
  opacity: 1;
  filter: alpha(opacity=100);
  transform: scale(1);
  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
}

.title {
  display: flex;
  margin-top: 15px;
  align-items: center;
}

.title img {
  width: 14px;
  height: 16px;
  margin-right: 5px;
}

.title p {
  flex: 1;
}

.el-carousel__item .carouseldiv {
  color: #475669;

  width: 264px;
  height: 213px;
  margin: 0 auto;
  /* background: #0f0; */
}

.el-carousel__item .carouseltv {
  line-height: 36px;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.el-carousel__item .carouseltvcheck {
  line-height: 18px;
  font-size: 14px;
  color: #ffffff;
  height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.right {
  width: 510px;
  height: 46px;
  background: linear-gradient(rgba(215, 215, 215, 0.4) 0%,
      rgba(248, 248, 248, 0.4) 100%);
}

.more {
  width: auto;
  height: 46px;
  color: #999999;
  display: flex;
  align-items: center;
  line-height: 16px;
  font-size: 14px;
  padding: 0 26px;
  cursor: pointer;
  flex: 1;
  display: flex;
  flex-direction: row-reverse;
}

.bar {
  width: 54px;
  height: 46px;
  color: #000;
  font-weight: 400;
  line-height: 18px;
  font-size: 16px;
  display: flex;
  align-items: center;

  /* justify-content: center; */
  cursor: pointer;
  /* opacity: 0.5;
  transition: opacity 0.5s; */
}

.bar:hover {
  background: #d30000;
  color: #f9f9f9;
}

.active {
  background: #d30000;
  margin-left: -1px;
  color: #f9f9f9;
}

.itemIndex {
  width: 100%;
  height: 31px;
  font-size: 14px;
  padding: 0 15px;
  font-weight: 400;
  text-align: left;
  color: #333333;
  cursor: pointer;
  line-height: 31px;
}

.itemIndex:hover p {
  color: #d30000;
}

/* .el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  transform: scale(0.68);
  background-color: #d3dce6;
} */
</style>



// WEBPACK FOOTER //
// src/views/home.vue